import type { Player } from '../types'

export interface RaidPlayerLiveLink {
  readonly playerId: string | null
  readonly discordUserId: string
}

/**
 * Resolve the current live-board row behind a raid snapshot player.
 *
 * A direct `playerId` link wins because it is the server-authored FK. The
 * Discord identity fallback repairs the late-join window where Discord RSVP
 * creates the snapshot row before roster mirroring creates the live row, so
 * the snapshot permanently carries `playerId: null` until the server catches
 * up and relinks it.
 */
export function resolveLivePlayerForRaidPlayer(
  raidPlayer: RaidPlayerLiveLink,
  livePlayers: ReadonlyArray<Player>,
  livePlayersByDiscordId?: ReadonlyMap<string, Player>,
): Player | undefined {
  const linkedPlayer = raidPlayer.playerId === null
    ? undefined
    : livePlayers.find((player) => player.id === raidPlayer.playerId)

  return linkedPlayer
    ?? livePlayersByDiscordId?.get(raidPlayer.discordUserId)
    ?? livePlayers.find((player) => player.discordUserId === raidPlayer.discordUserId)
}
